var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaveManagementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.677,
    height: 24.677,
    viewBox: "0 0 24.677 24.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(-38.614 -546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(38.614 546)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(-1269.568 1281.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M1317.066-715.974a3.367,3.367,0,0,1-.536-.2,1.457,1.457,0,0,1-.781-1.34c0-1,0-2,0-2.993q0-3.989,0-7.977a1.5,1.5,0,0,1,1.167-1.515,1.729,1.729,0,0,1,.394-.042c1.648,0,3.3,0,4.943,0a1.573,1.573,0,0,1,1.128.451q1.269,1.206,2.544,2.405a1.635,1.635,0,0,1,.539,1.257c0,2.787-.009,5.575,0,8.362a1.531,1.531,0,0,1-1.287,1.57c-.012,0-.023.013-.035.02Zm5.109-13.24h-4.823a.7.7,0,0,0-.781.777q0,5.431,0,10.863a.7.7,0,0,0,.769.775h7.526a.7.7,0,0,0,.769-.775q0-4.092,0-8.185v-.159h-.162q-1.147,0-2.293,0a.961.961,0,0,1-1.005-1c0-.522,0-1.044,0-1.566Zm.832.409c0,.046-.008.064-.008.081q0,.9,0,1.8c0,.142.046.184.192.184h1.865c.032,0,.065-.007.117-.012Z",
    fill: "#59c680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M1369.339-557.033q-1.5,0-2.991,0a.41.41,0,0,1-.39-.6.407.407,0,0,1,.384-.218h5.983a.411.411,0,0,1,.406.587.418.418,0,0,1-.414.238q-1.434,0-2.868,0Z",
    transform: "translate(-48.319 -165.863)",
    fill: "#59c680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M1369.318-497.15q-1.489,0-2.978,0a.41.41,0,0,1-.4-.582.407.407,0,0,1,.4-.241h1.715q2.134,0,4.268,0a.411.411,0,0,1,.41.576.419.419,0,0,1-.421.249Q1370.814-497.152,1369.318-497.15Z",
    transform: "translate(-48.312 -223.548)",
    fill: "#59c680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M1361.94-683.857c0-.274,0-.53,0-.786a.416.416,0,0,1,.414-.45.417.417,0,0,1,.41.454c0,.247,0,.494,0,.741a.188.188,0,0,0,.014.04c.263,0,.531,0,.8,0a.408.408,0,0,1,.371.6.4.4,0,0,1-.381.223h-.806c0,.264,0,.514,0,.765a.421.421,0,0,1-.407.471.421.421,0,0,1-.417-.475c0-.247,0-.494,0-.761h-.59c-.073,0-.146,0-.22,0a.415.415,0,0,1-.426-.41.413.413,0,0,1,.423-.412C1361.392-683.86,1361.657-683.857,1361.94-683.857Z",
    transform: "translate(-43.308 -43.296)",
    fill: "#59c680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M1367.358-438.1c.32,0,.641,0,.961,0a.42.42,0,0,1,.447.405.419.419,0,0,1-.448.418q-.968,0-1.936,0a.414.414,0,0,1-.438-.412.415.415,0,0,1,.439-.411C1366.708-438.1,1367.033-438.1,1367.358-438.1Z",
    transform: "translate(-48.356 -281.225)",
    fill: "#59c680"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveManagementIcon);
export default __webpack_public_path__ + "static/media/LeaveManagementIcon.86518b754612c4d1c886a415209d3a14.svg";
export { ForwardRef as ReactComponent };